import {
  FileExcelOutlined,
  FileImageOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileZipOutlined,
} from "@ant-design/icons";

const IconAttachment = ({ fileName, ...props }) => {
  const formattedFileName = fileName.split(".");
  const fileType =
    formattedFileName.length > 0
      ? formattedFileName[formattedFileName.length - 1]
      : null;
  switch (fileType) {
    case "pdf":
      return <FilePdfOutlined {...props} />;
    case "xls":
    case "xlsx":
    case "csv":
      return <FileExcelOutlined {...props} />;
    case "png":
    case "jpg":
    case "jpeg":
    case "webp":
    case "heic":
    case "heif":
      return <FileImageOutlined {...props} />;
    case "doc":
    case "docx":
      return <FileWordOutlined {...props} />;
    case "zip":
    case "rar":
      return <FileZipOutlined {...props} />;
    default:
      return <FileOutlined {...props} />;
  }
};

export default IconAttachment;
